export default "__VITE_ASSET__3a110637__"